export default {
  dataIterator: {
    rowsPerPageText: 'Elemente pro Seite:',
    rowsPerPageAll: 'Alle',
    pageText: '{0}-{1} von {2}',
    noResultsText: 'Keine Elemente gefunden',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
  },
  dataTable: {
    rowsPerPageText: 'Zeilen pro Seite:',
  },
  noDataText: 'Keine Daten vorhanden',
};
